import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_show_plans,
    redirect: { name: 'not-found' },
});